<div #container>
    <h1 class="page-title">Api Key Management</h1>
    <div style="background-color: #fffae6; border-left: 5px solid #ffcc00; padding: 10px; margin: 15px 0; font-weight: bold;">
        Please follow the procedure described in this 
        <a href="https://user.eumetsat.int/resources/user-guides/introductory-data-store-user-guide#ID-Authentication-and-login" target="_blank" style="color: #d35400; text-decoration: underline;">link</a> 
        to migrate to the new authentication method.
    </div>

    <div class="page-content">
        <div class="section">
            <h3 class="is-size-5 has-text-link">User credentials</h3>
            <div class="section-content">
                <label class="label">Consumer key</label>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input" [type]="hideKeys ? 'password': 'text'" readonly="readonly" id="consumer-key" [ngModel]="consumerKey">
                    </div>
                    <div class="control">
                        <a class="button clipboard" [attr.data-clipboard-text]="consumerKey">
                            <span class="icon is-small">
                                <i class="mdi mdi-content-copy"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <label class="label">Consumer secret</label>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input" [type]="hideKeys ? 'password': 'text'" readonly="readonly" id="consumer-secret" [ngModel]="consumerSecret">
                    </div>
                    <div class="control">
                        <a class="button clipboard" [attr.data-clipboard-text]="consumerSecret">
                            <span class="icon is-small">
                                <i class="mdi mdi-content-copy"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="hint">
                    It is possible to generate an API access token by calling the token API service using the credentials provided above.
                    Below the cURL command:
                </div>
                <div class="command">
                    <pre><code>{{getTokenGenCurlCommand()}}</code></pre>
                    <a class="clipboard" [attr.data-clipboard-text]="getTokenGenCurlCommand(true)">
                        <span class="icon is-small">
                            <i class="mdi mdi-content-copy"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="section">
            <h3 class="is-size-5 has-text-link">API Token</h3>
            <div class="section-content">
                <div class="hint">
                    The following token can be used to access the APIs. It has a validity of one hour
                </div>
                <label class="label">API token</label>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input" [type]="hideKeys ? 'password': 'text'" readonly="readonly" id="api-token" [ngModel]="apiToken">
                    </div>
                    <div class="control">
                        <a class="button clipboard" [attr.data-clipboard-text]="apiToken">
                            <span class="icon is-small">
                                <i class="mdi mdi-content-copy"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="hint">
                    It should be added in the http header of each API call as shown in the following sample cURL command:
                </div>
                <div class="command">
                    <pre><code>{{getApiCurlCommand()}}</code></pre>
                    <a class="clipboard" [attr.data-clipboard-text]="getApiCurlCommand(true)">
                        <span class="icon is-small">
                            <i class="mdi mdi-content-copy"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="actions">
            <a class="button has-text" (click)="refreshToken()">
                <span>Refresh token</span>
                <span class="icon">
                    <i class="mdi mdi-refresh"></i>
                </span>
            </a>
            <a class="button has-text" (click)="hideKeys = !hideKeys">
                <span>{{hideKeys ? 'Show hidden fields': 'Hide sensitive fields'}}</span>
                <span class="icon">
                    <i class="mdi mdi-eye" *ngIf="hideKeys"></i>
                    <i class="mdi mdi-eye-off" *ngIf="!hideKeys"></i>
                </span>
            </a>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/main/components/api-keys/api-keys.component.html